import React, { useCallback } from "react";
import classNames from "classnames";
import { TabControlerType, TabType } from "./types";
import "./TabControler.scss";
import { useTranslation } from "react-i18next";

export function TabControler<T>({
  changePage,
  tabs,
  clickable = true,
}: TabControlerType<T>) {
  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const actualTab = params.get('tab');
  const onTabClicked = useCallback(
    (tab: TabType<T>) => {
      if (
        (actualTab !== tab?.id || clickable) &&
        !tab.disabled &&
        changePage
      ) {
        changePage(tab.id);
      }
    },
    [actualTab, changePage, clickable]
  );

  const renderTabs = useCallback(() => {
    return tabs.map((tab, index) => {
      const Icon = tab?.icon as React.FC;

      return (
        <div
          key={index}
          id={`${tab?.id || ""}`}
          data-testId={`${tab?.testId || ""}`}
          onClick={() => onTabClicked(tab)}
          className={classNames("container-tab", {
            "cursor-pointer": clickable,
            "container-tab-active": actualTab === tab.id,
            "container-tab-disabled": tab.disabled,
          })}
        >
          <p
            className="tab-name"
            data-testId={`${`${tab?.testId}-label` || ""}`}
          >
            {t(tab?.title || "")}
          </p>
          {Icon && <Icon />}
        </div>
      );
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs, clickable, t, onTabClicked]);

  return <div className="flex-tab background-tab">{renderTabs()}</div>;
}
